"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[8101],{

/***/ 64303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const CouponApplyDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CouponApply"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "CouponApplyInput"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "validateOnly"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Boolean"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "gender"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "UserGender"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "couponApply"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "coupon"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "type"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "code"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "discountAmount"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "discountPercentage"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "shouldCharge"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "chargeAmount"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "extraShippingPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "marketingCouponOfferType"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "origin"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "freeProduct"
                                                            },
                                                            "arguments": [
                                                                {
                                                                    "kind": "Argument",
                                                                    "name": {
                                                                        "kind": "Name",
                                                                        "value": "gender"
                                                                    },
                                                                    "value": {
                                                                        "kind": "Variable",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "gender"
                                                                        }
                                                                    }
                                                                }
                                                            ],
                                                            "directives": [
                                                                {
                                                                    "kind": "Directive",
                                                                    "name": {
                                                                        "kind": "Name",
                                                                        "value": "include"
                                                                    },
                                                                    "arguments": [
                                                                        {
                                                                            "kind": "Argument",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "if"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "validateOnly"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "brandInfo"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "name"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "image"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "rebrandImage"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "typeGroup"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "rating"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "avgRate"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "couponApplyPeriod"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "CouponError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "couponErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "BusinessError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "businessErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
CouponApplyDocument["definitions"] = [
    ...new Set(CouponApplyDocument.definitions)
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CouponApplyDocument);


/***/ }),

/***/ 63450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ useApplyCouponCallback),
/* harmony export */   s: () => (/* binding */ useApplyCoupon)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83115);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41146);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83901);
/* harmony import */ var _useCouponData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5881);
/* harmony import */ var _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64303);





// lightweight variant for applying coupon on payment page
const useApplyCouponCallback = ()=>{
    const apolloClient = (0,apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useApolloClient */ .x)();
    const resetCouponsCache = (0,_useCouponData__WEBPACK_IMPORTED_MODULE_2__/* .useResetCouponsCache */ .P)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (input)=>{
        const result = await apolloClient.mutate({
            mutation: _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            variables: {
                input,
                validateOnly: false,
                gender: null
            },
            fetchPolicy: "no-cache"
        });
        resetCouponsCache();
        // evict applied coupon cache for the cart
        apolloClient.cache.evict({
            id: "ROOT_QUERY",
            fieldName: "purchaseInquiry:InquireSubscriptionCoupon"
        });
        if (result.errors) {
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .GraphQLError */ .__(result.errors);
        }
        const { data, error } = result.data.couponApply;
        if (error) {
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error);
        }
        return data;
    }, [
        apolloClient,
        resetCouponsCache
    ]);
};
const useApplyCoupon = ()=>{
    const [mutate, { isFetching, client: apolloClient }] = (0,apollo_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fetchPolicy: "no-cache"
    });
    const resetCouponsCache = (0,_useCouponData__WEBPACK_IMPORTED_MODULE_2__/* .useResetCouponsCache */ .P)();
    const submit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (input, refetchQueries)=>{
        const result = await mutate({
            variables: {
                input,
                validateOnly: false,
                gender: null
            },
            refetchQueries
        });
        resetCouponsCache();
        // evict applied coupon cache for the cart
        apolloClient.cache.evict({
            id: "ROOT_QUERY",
            fieldName: "purchaseInquiry:InquireSubscriptionCoupon"
        });
        if (result.errors) {
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .GraphQLError */ .__(result.errors);
        }
        const { data, error } = result.data.couponApply;
        if (error) {
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error);
        }
        return data;
    }, [
        mutate,
        resetCouponsCache,
        apolloClient
    ]);
    return [
        submit,
        {
            isFetching
        }
    ];
};


/***/ }),

/***/ 28585:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68426);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51827);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50556);




const useCookieCoupon = (defaultCoupon)=>{
    const isDefaultCoupon50Enabled = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.features.defaultCoupon50);
    const isHoliday22Sub60Enabled = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.features.holiday22Sub60);
    const isPlanSelectionInPaymentEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.abTests.paymentPlanSelection) === "b";
    let fallbackCoupon;
    if (isHoliday22Sub60Enabled) {
        fallbackCoupon = "HD60";
    } else if (isDefaultCoupon50Enabled) {
        fallbackCoupon = isPlanSelectionInPaymentEnabled ? "HD50CRO" : "HD50";
    } else {
        fallbackCoupon = isPlanSelectionInPaymentEnabled ? "HD25CRO" : "HD25";
    }
    const realDefaultCoupon = typeof defaultCoupon === "undefined" ? fallbackCoupon : defaultCoupon;
    const getCookieCoupons = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const cookieCouponCode = cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.discountCoupon) // coupon from landings
        ;
        const appliedCouponCode = cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.appliedCouponCode);
        const couponCode = cookieCouponCode === undefined ? realDefaultCoupon : cookieCouponCode // cookieCouponCode may be null for "no discount" flow
        ;
        return {
            couponCode,
            cookieCouponCode,
            appliedCouponCode
        };
    }, [
        realDefaultCoupon
    ]);
    const setCookieCoupon = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((code)=>{
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.removeItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.appliedCouponCode);
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.discountCoupon, code);
        if (code === "FREE_TRIAL") {
            cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon, true);
        } else {
            cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.removeItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon);
        }
    }, []);
    const data = getCookieCoupons();
    return {
        ...data,
        getCookieCoupons,
        setCookieCoupon
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCookieCoupon);


/***/ }),

/***/ 5881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ useResetCouponsCache),
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40454);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83115);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36403);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58738);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83901);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17382);
/* harmony import */ var _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64303);






const modifyResult = (data)=>{
    if (!data) {
        return null;
    }
    const { coupon, totalAmount, couponApplyPeriod } = data;
    return {
        ...coupon,
        totalAmount,
        couponApplyPeriod
    };
};
// empty object or undefined means the value is fetching, null means it's fetched but not available
const couponDataVar = (0,apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .makeVar */ .QS)({});
const useResetCouponsCache = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        couponDataVar({});
    }, []);
};
// ATTN this hook is for reading-only
const useCouponData = function() {
    let { couponCode: userCouponCode, origin } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { gender } = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)();
    const apolloClient = (0,apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useApolloClient */ .x)();
    const couponDataCache = (0,apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useReactiveVar */ .l)(couponDataVar);
    const couponCode = userCouponCode?.toUpperCase();
    const cacheKey = couponCode ? `COUPON-APPLY-${couponCode}-${gender}` : null;
    const rawCouponData = couponDataCache[cacheKey];
    const isDataAvailable = Boolean(rawCouponData) // required to refetch after data reset
    ;
    const couponData = rawCouponData?.data;
    const isCouponDataFetching = cacheKey ? couponData === undefined : false;
    const isCouponUnavailable = cacheKey ? couponData === null : false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const fetchCouponData = async ()=>{
            try {
                if (!couponCode) {
                    return;
                }
                const result = await apolloClient.mutate({
                    mutation: _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                    variables: {
                        input: {
                            couponCode,
                            origin,
                            validateOnly: true
                        },
                        gender,
                        validateOnly: true
                    },
                    fetchPolicy: "no-cache"
                });
                if (result.errors) {
                    throw new helpers__WEBPACK_IMPORTED_MODULE_6__/* .GraphQLError */ .__(result.errors);
                }
                const { data } = result.data.couponApply;
                return modifyResult(data);
            } catch (error) {
                logger__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.info(error);
            }
        };
        if (!cacheKey) {
            return;
        }
        const lastCacheValue = couponDataVar();
        if (!lastCacheValue[cacheKey]) {
            // data is undefined, but promise is fired
            couponDataVar({
                ...lastCacheValue,
                [cacheKey]: {
                    data: undefined
                }
            });
            fetchCouponData().then((data)=>{
                couponDataVar({
                    ...couponDataVar(),
                    [cacheKey]: {
                        data
                    }
                });
            }).catch(()=>{
                couponDataVar({
                    ...couponDataVar(),
                    // reset cache
                    [cacheKey]: undefined
                });
            });
        }
    }, [
        cacheKey,
        origin,
        couponCode,
        apolloClient,
        gender,
        isDataAvailable
    ]);
    return {
        couponData,
        isCouponDataFetching,
        isCouponUnavailable
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCouponData);


/***/ }),

/***/ 24827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ coupon_useInquireSubscriptionCoupon)
});

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(61420);
;// CONCATENATED MODULE: ./src/modules/coupon/graph/inquireSubscriptionCoupon.graphql.ts
const InquireSubscriptionCouponDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InquireSubscriptionCoupon"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "purchaseInquiry"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "purchaseLevel"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "ALL"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "directives": [
                            {
                                "kind": "Directive",
                                "name": {
                                    "kind": "Name",
                                    "value": "connection"
                                },
                                "arguments": [
                                    {
                                        "kind": "Argument",
                                        "name": {
                                            "kind": "Name",
                                            "value": "key"
                                        },
                                        "value": {
                                            "kind": "StringValue",
                                            "value": "InquireSubscriptionCoupon",
                                            "block": false
                                        }
                                    },
                                    {
                                        "kind": "Argument",
                                        "name": {
                                            "kind": "Name",
                                            "value": "filter"
                                        },
                                        "value": {
                                            "kind": "ListValue",
                                            "values": []
                                        }
                                    }
                                ]
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "items"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "subscription"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "coupon"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "code"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
InquireSubscriptionCouponDocument["definitions"] = [
    ...new Set(InquireSubscriptionCouponDocument.definitions)
];
/* harmony default export */ const inquireSubscriptionCoupon_graphql = (InquireSubscriptionCouponDocument);

;// CONCATENATED MODULE: ./src/modules/coupon/useInquireSubscriptionCoupon.ts


// returns applied coupon from user's session
const useInquireSubscriptionCoupon = function() {
    let { skip } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data, isFetching } = (0,useQuery/* default */.Z)(inquireSubscriptionCoupon_graphql, {
        ssr: false,
        errorPolicy: "ignore",
        skip
    });
    const inquireSubscriptionCouponCode = data?.purchaseInquiry?.data?.items?.subscription?.coupon?.code;
    return {
        inquireSubscriptionCouponCode,
        isFetching
    };
};
/* harmony default export */ const coupon_useInquireSubscriptionCoupon = (useInquireSubscriptionCoupon);


/***/ })

}]);